import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { commonClass } from "../../helpers/commonClass";
import { history } from "../../helpers/history";


class PreviousDrawShows extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drawtype: props.drawtype,
            pastDrawShow: [],
            iframedrawurl: "",
            currentPageNo: 0,
            NumberofRecord: 6,
            totalPage: 0,
            startinx: 0,
            endinx: 6,
            lfilterdt: [],
            IsValidData: false,
            _dbdrawType: props.send_db_id,
            Allyear: [],
            Allmonth: [{ 'monthName': 'January', 'value': 0 }, { 'monthName': 'February', 'value': 1 }, { 'monthName': 'March', 'value': 2 }, { 'monthName': 'April', 'value': 3 }, { 'monthName': 'May', 'value': 4 }, { 'monthName': 'June', 'value': 5 }, { 'monthName': 'July', 'value': 6 }, { 'monthName': 'August', 'value': 7 }, { 'monthName': 'September', 'value': 8 }, { 'monthName': 'October', 'value': 9 }, { 'monthName': 'November', 'value': 10 }, { 'monthName': 'December', 'value': 11 }],
            CurrentYear: '2025',
            CurrentMonth: {},
            myfavNoID: 0,
            FTPAll: []
        }
    }

    LoadCurrentYear = () => {
        let startyear = 2023;
        let cDate = new Date();
        let cYear = cDate.getFullYear();
        let MonthVal = cDate.getMonth();
        let setyear = [];
        for (let index = startyear; index <= cYear; index++) {
            setyear.push(index + '')
        }
        cYear = cYear + '';
        let getMonthobj = this.state.Allmonth.filter(a => a.value == MonthVal);
        this.setState({ CurrentMonth: getMonthobj[0] });
        this.setState({ CurrentYear: cYear });
        setyear = setyear.filter(a => parseInt(a) <= parseInt(cYear));
        this.setState({ Allyear: setyear });
    }


    componentDidMount() {
        localStorage.setItem('drawtabId', 2);
        setTimeout(() => {
            this.setjsondata()
        }, 100);
    }
    setClass = () => {
        window.AddClass()
    }

    componentDidUpdate(prevState, prevProps) {
        if (this.state.pastDrawShow && this.state.pastDrawShow !== prevProps.pastDrawShow && this.state.pastDrawShow.length != 0 && this.state.IsValidData == false) {
            this.state.IsValidData = true;
            this.setState({ IsValidData: true })
            this.LoadPastDrawShowData();
            setTimeout(() => {
                this.setClass();
            }, 300);
        }
    }

    SetiframeUrl = (url) => {
        this.setState({ iframedrawurl: url })
    }
    setjsondata = () => {
        try {
            let hbanner = 0
            if (this.props.appvariables.bVersion) {
                let hbannerVer = this.props.appvariables.bVersion.split("~")
                if (hbannerVer.length > 2) {
                    hbanner = hbannerVer[3]
                }
            }
            // let path = this.state.CurrentYear + '';
            // fetch(process.env.REACT_APP_CDN_URL + `Web/${path}/ResultUrlUpload.json` + "?V" + hbanner)
            fetch(process.env.REACT_APP_CDN_URL + 'Web/ResultUrlUpload.json' + "?V" + hbanner)
                .then(response => response.json())
                .then(data => {
                    this.setState({ pastDrawShow: data.ResultUrlList.filter(a => a.GameTypeId == this.state._dbdrawType) })
                });
        }
        catch (ex) {
            console.log("setjsondata => " + ex)
        }
    };

    loadnxtdata = (st) => {
        if (st == "+") {
            if (this.state.currentPageNo != this.state.totalPage) {
                this.state.currentPageNo = this.state.currentPageNo + 1;
            }
        }
        else if (st == "-") {
            if (this.state.currentPageNo != 0) {
                this.state.currentPageNo = this.state.currentPageNo - 1;
            }
        }
        else if (st == "first") {
            this.state.currentPageNo = 0;
        }
        else if (st == "last") {
            this.state.currentPageNo = this.state.totalPage;
        }
        let _startinx = this.state.currentPageNo * this.state.NumberofRecord;
        let _endinx = _startinx + this.state.NumberofRecord;
        this.setState({ startinx: _startinx, endinx: _endinx });
    }


    LoadPastDrawShowData = () => {
        if (this.state.pastDrawShow && this.state.pastDrawShow.length > 0) {
            this.setState({ lfilterdt: this.state.pastDrawShow });
            let ltotpage = Math.trunc(this.state.pastDrawShow.length / this.state.NumberofRecord);
            let ltotpage1 = Math.trunc(this.state.pastDrawShow.length % this.state.NumberofRecord);
            if (ltotpage1 == 0) {
                ltotpage = ltotpage - 1;
            }
            this.setState({ currentPageNo: 0 });
            this.setState({ totalPage: ltotpage })
            this.setState({ startinx: 0, endinx: this.state.NumberofRecord });
            setTimeout(() => {
                window.allDrawResultPopUp();
            }, 1000);
        }
        else {
            this.setState({ lfilterdt: [] });
        }
    }

    setCyear = (e) => {
        this.setState({ CurrentYear: e.target.value })
    }

    setCMonth = (e) => {
        let Getmonth = this.state.Allmonth.filter(a => a.value == e.target.value);
        this.state.CurrentMonth = Getmonth[0];
        const Getfdata = this.GetFilterdValues(this.state.FTPAll);
        this.setState({ pastDrawShow: Getfdata });
    }

    GetFilterdValues = (dataSet) => {
        let data = dataSet;
        let filterddata = [];
        const doubledNumbers = data.map((number) => {
            const dateString = number.DrawDate
            const date = new Date(dateString);
            const monthIndex = date.getMonth();
            const year = date.getFullYear() + ''
            // if (this.state.CurrentYear === year) {
            if (this.state.CurrentMonth.value == monthIndex) {
                filterddata.push(number)
            }
            // }
        });
        return filterddata;
    }

    render() {
        // let iframeUrl = this.props.drawtype == 9 ? "https://www.youtube.com/embed/Rzj_vbur3rA?si=ODV99mYnMrz5tg66" : "https://www.youtube.com/embed/mHm-t2DWLrM?si=3T7TGGsFidG3PCjj"
        const { t } = this.props
        return (
            <>
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-Past-Draw-Shows.png" />{t('lblPastDrawShow')}</h1>
                </div>

                {/* <div className={`profileCont mydrawtabs ${this.props.drawtype == 2 ? "topAlign" : ""} pb-14`}> */}
                {/* <div className="popup-container bigpopup" id="popup-container1" >
                        <div className="popup-content !w-fit !min-w-min px-10 no-scrollbar">
                            <div className="rightAlign">
                                <button className="close-popup crossBtn borderFade bigpopupclose" id="close-popup1" onClick={() => { this.SetiframeUrl("") }}>
                                    <img src="./assets/img/icons/Close-Btn.svg" alt="Close Icon" />
                                </button>
                            </div>
                            <div className="popup-main !px-8 flex justify-center items-center">
                                <iframe
                                    width="700"
                                    height="455"
                                    src={this.state.iframedrawurl + '&rel=0'}
                                    title="YouTube video player"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                    className="rounded-md"
                                    style={{ border: "0px" }}
                                ></iframe>
                            </div>
                        </div>
                    </div> */}

                <div class="pastDrawShows">
                    {this.state.IsValidData && this.state.pastDrawShow && this.state.pastDrawShow.length > 0 && this.state.pastDrawShow.slice(this.state.startinx, this.state.endinx).map((x, inx) =>
                        <div class="pastDrawShowsLi">
                            <iframe
                                src={x.VideoUrl + '&rel=0'}
                                frameborder="0"
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                className="rounded-md iframeborder"
                                allowFullScreen
                            >
                            </iframe>
                            <div class="pastDrawShowDetls">
                                <h3> {x.DrawDate}</h3>
                                <div>
                                    <img src="./assets/img/icons/winner.png" />
                                    <span> {t('lblTotwinner')} :</span>
                                    <span>&nbsp;{x.TotalWinners}</span>
                                </div>
                                <div>
                                    <img src="./assets/img/icons/cash-backs-2.png" />
                                    <span> {t('lblTotalPrizes')} &nbsp;&nbsp;&nbsp;&nbsp;:</span>
                                    <span>&nbsp;{this.props.appvariables.currency} {commonClass.aedCrnyConvert(x.TotalPrizes)}</span>
                                </div>
                            </div>

                            {/* <div className="flex gap-8 items-center border-slate-500 border-[1.5px] p-10 rounded-xl shadow-lg bg-neutral-50" key={`ah_${inx}`}>
                                    <div className="flex flex-col gap-2 items-start">
                                        <h2 className="text-lg md:text-xl lg:text-2xl font-bold uppercase mx-auto">
                                            {x.DrawDate}
                                        </h2>
                                        <div>
                                            <div className="flex gap-6">
                                                <h4 className="text-base font-semibold md:text-lg uppercase min-w-36">
                                                    {t('lblTotwinner')} :
                                                </h4>
                                                <p className="text-base md:text-lg">{x.TotalWinners}</p>
                                            </div>
                                            <div className="flex gap-6">
                                                <h4 className="text-base font-semibold md:text-lg uppercase min-w-36">
                                                    {t('lblTotalPrizes')} :
                                                </h4>
                                                <p className="text-base md:text-lg">{this.props.appvariables.currency} {commonClass.aedCrnyConvert(x.TotalPrizes)}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div> */}

                        </div>
                    )}
                    <>
                        {(!this.state.pastDrawShow || this.state.pastDrawShow.length <= 0) &&
                            <div class="noOrders">
                                <img src="./assets/img/icons/sad.png" />
                                <h3>{t("lblNoDrawsAvailable")}</h3>
                                <p class="margin-bottom-20">{t("lblDrawsIsEmpty")}</p>
                                <div class="formCont updateBtn">
                                    <button onClick={() => { history.push("/") }}>{t('lblBuynow')}</button>
                                </div>
                            </div>}
                    </>
                </div>

                <div class="pagination">
                    <div class="paginationLft">
                        {t('lblshowing')} <span>{this.state.currentPageNo + 1}</span> {t('lblto')} <span>{Math.ceil(this.state.pastDrawShow.length / this.state.NumberofRecord)}</span> {t('lblof')} <span>{this.state.pastDrawShow.length}</span> {t('lblentries')}
                    </div>
                    <div class="paginationLRht">
                        <a onClick={() => this.loadnxtdata("first")}><img src="./assets/img/icons/paginate-2-lft.png" /></a>
                        <a class="" onClick={() => this.loadnxtdata("-")}><img src="./assets/img/icons/paginate-1-lft.png" /></a>
                        <a class="" onClick={() => this.loadnxtdata("+")}><img src="./assets/img/icons/paginate-1-rht.png" /></a>
                        <a onClick={() => this.loadnxtdata("last")} class="" ><img src="./assets/img/icons/paginate-2-rht.png" /></a>
                    </div>
                </div>

            </>

        );
    }
}


function mapStateToProps(state) {
    const { appvariables } = state.loginReducer;
    return { appvariables };

}
export default connect(mapStateToProps)(withTranslation()(PreviousDrawShows))